// /api/jobs/recommend — Session 7 PR2 centroid recommendations.

import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import type { JobRow } from "./jobs";

export interface RecommendationsResponse {
  jobs: JobRow[];
  returned: number;
  // Always present. 0 means "no progressed apps yet" → empty-state copy.
  progressed_count: number;
  // Only present when the centroid was empty. Lets the SPA render the
  // "land an interview to sharpen this list" message instead of "no
  // matches" — the two failure modes are very different.
  reason?: "insufficient_data";
  // `centroid` once an interview exists; `cold_start` when recommendations
  // are derived from the career corpus + prefs (no interviews yet). Absent
  // on the insufficient_data empty state.
  source?: "centroid" | "cold_start";
}

export function useRecommendations(n = 3) {
  return useQuery({
    queryKey: ["recommend", n],
    queryFn: () => api<RecommendationsResponse>(`/api/jobs/recommend?n=${n}`),
    // Server-side KV cache is 5 min; client revalidates every 60s.
    staleTime: 60_000,
  });
}
